export default "__VITE_ASSET__DF5wPxSK__"